"use server"

import { sdk } from "@lib/config"
import { getAuthHeaders, getCacheOptions } from "./cookies"

type RestockSubscription = {
  id: string
  variant_id: string
  sales_channel_id: string
  email: string
  customer_id: string | null
}

export const subscribeToRestock = async (
  variantId: string,
  email?: string
): Promise<{ success: boolean; error: string | null }> => {
  try {
    const headers = { ...(await getAuthHeaders()) }
    await sdk.client.fetch(`/store/restock-subscriptions`, {
      method: "POST",
      body: { variant_id: variantId, email },
      headers,
    })
    return { success: true, error: null }
  } catch (err: any) {
    return { success: false, error: err.message || "Failed to subscribe" }
  }
}

export const listRestockSubscriptions = async (): Promise<RestockSubscription[]> => {
  const headers = { ...(await getAuthHeaders()) }
  const next = { ...(await getCacheOptions("restock-subscriptions")) }

  return sdk.client
    .fetch<{ subscriptions: RestockSubscription[] }>(`/store/restock-subscriptions`, {
      method: "GET",
      headers,
      next,
      cache: "force-cache",
    })
    .then(({ subscriptions }) => subscriptions)
    .catch(() => [])
}

export const deleteRestockSubscription = async (
  id: string
): Promise<{ success: boolean; error: string | null }> => {
  const headers = { ...(await getAuthHeaders()) }
  return sdk.client
    .fetch(`/store/restock-subscriptions/${id}`, { method: "DELETE", headers })
    .then(() => ({ success: true, error: null }))
    .catch((err: any) => ({ success: false, error: err.message || "Failed to unsubscribe" }))
}

export const getGlobalNotificationStatus = async (): Promise<boolean> => {
  const headers = { ...(await getAuthHeaders()) }
  return sdk.client
    .fetch<{ subscribed: boolean }>(`/store/restock-subscriptions/global`, {
      method: "GET",
      headers,
    })
    .then(({ subscribed }) => subscribed)
    .catch(() => false)
}

export const setGlobalNotificationStatus = async (
  enabled: boolean
): Promise<{ success: boolean; error: string | null }> => {
  try {
    const headers = { ...(await getAuthHeaders()) }
    await sdk.client.fetch(`/store/restock-subscriptions/global`, {
      method: enabled ? "POST" : "DELETE",
      headers,
    })
    return { success: true, error: null }
  } catch (err: any) {
    return { success: false, error: err.message || "Failed to update notification setting" }
  }
}
